import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import Comments from 'components/UI/ChatBox/Comments';
import store from 'stores/RootStore';
import { ViewModes } from 'types/ViewModes';

import AdView from '../Shared/AdView/AdView';
import AdList from './AdList/AdList';

const Container = styled.div.attrs({
  className: 'creative-root',
})`
  display: grid;
  grid-template-columns: 500px 1fr;
  height: 100%;
  position: relative;
`;

function TearsheetDesktopView() {
  const store_tearsheet = store.tearsheet;
  const store_user = store.user;
  const currentAd = store_tearsheet?.ads?.current;

  const framelessMode = store.ui.viewMode === ViewModes.FRAMELESS;

  if (store_tearsheet) {
    if (framelessMode) {
      return <AdView variant="desktop" />;
    }
    return (
      <Container>
        <AdList />
        <AdView variant="desktop" />
        {currentAd && (
          <Comments
            parentDoc={currentAd}
            user={store_user}
            variant="floating"
          />
        )}
      </Container>
    );
  }
  return null;
}

export default observer(TearsheetDesktopView);
